import axios from '@_system/axios/axios.js'
export default {
	path: '/goodsprofit',
	list(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	save(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},



	get(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	update(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.put(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	delete(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.delete(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	init(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get('moduleConfig/admin/goodsprofit.goodsprofit', data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	listprofit(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/listprofit', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	getgoodsspu(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path+'/getgoodsspu', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
}
